import { memo } from 'react';
import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

const PinIcon = (props: IconWrapperProps) => {
  return (
    <IconWrapper viewBox="0 0 12 16" {...props}>
      <g fill="currentColor" clipPath="url(#a)">
        <path d="M5.76 16a.705.705 0 0 1-.576-.31c-.146-.23-3.566-5.487-4.571-7.425-.169-.3-.3-.62-.394-.95A5.842 5.842 0 0 1 0 5.76a5.77 5.77 0 0 1 11.53 0 5.849 5.849 0 0 1-.23 1.554c-.07.318-.18.625-.329.915-1.042 1.91-4.47 7.195-4.617 7.424A.686.686 0 0 1 5.76 16Zm0-14.629A4.389 4.389 0 0 0 1.371 5.76c0 .408.055.814.165 1.207.059.22.138.435.238.64.768 1.399 2.944 4.809 3.986 6.4 1.051-1.637 3.227-5.047 3.986-6.4.104-.204.184-.418.238-.64a4.48 4.48 0 0 0 .174-1.207A4.398 4.398 0 0 0 5.76 1.371Z" />
        <path d="M5.76 7.314a1.829 1.829 0 1 1-.017-3.657 1.829 1.829 0 0 1 .017 3.657Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="currentColor" d="M0 0h11.529v16H0z" />
        </clipPath>
      </defs>
    </IconWrapper>
  );
};
export default memo(PinIcon);
